// Read-only client for the public introsite API. It carries no credentials of
// its own and only ever receives the explicitly shaped public payloads.
const SITE_URL = '/api/intro/site';
const MEMBERS_URL = '/api/intro/members';
const BOARDS_URL = '/api/intro/boards';
const ALBUMS_URL = '/api/intro/albums';

function getJson(url) {
  // no-cache revalidates with the ETag (a cheap 304 when nothing changed), so a CMS save
  // shows on the next visit instead of after the browser's max-age.
  return fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-cache' })
    .then((response) => {
      if (!response.ok) {
        // The status lets a caller tell "this does not exist" (404) from a failure.
        throw Object.assign(new Error(`Request to ${url} failed with status ${response.status}`), { status: response.status });
      }

      return response.json();
    })
    .then(body => body.data);
}

export default {
  fetchSite() {
    return getJson(SITE_URL);
  },

  fetchMembers() {
    return getJson(MEMBERS_URL);
  },

  fetchBoards() {
    return getJson(BOARDS_URL);
  },

  fetchAlbums() {
    return getJson(ALBUMS_URL);
  },

  fetchAlbum(slug) {
    return getJson(`${ALBUMS_URL}/${encodeURIComponent(slug)}`);
  },
};
